"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("..");
var EntryPicker_1 = require("../../Inputs/EntryPicker");
exports.default = (function (controlProps) {
    return React.createElement(__1.FormikWrapper, { Label: controlProps.Label, HelperText: controlProps.HelperText, Name: controlProps.Name, FormikProps: controlProps.FormikProps, Disabled: controlProps.Disabled, ShowRequired: controlProps.ShowRequired, RenderControl: function (_, _a, hasErrors) {
            var field = _a.field, form = _a.form;
            return (React.createElement(EntryPicker_1.EntryPicker, __assign({ HasErrors: hasErrors }, controlProps, { OnChange: function (value) {
                    // There is a bug with validation in <Form /> if you setFieldValue to undefined.
                    if (value === undefined) {
                        form.setFieldValue(field.name, null);
                    }
                    else {
                        form.setFieldValue(field.name, value);
                    }
                }, OnBlur: function () {
                    form.setFieldTouched(field.name, true);
                }, Value: field.value, IsDisabled: controlProps.Disabled })));
        } });
});
